export const createObjectURL = (file: File) =>
    (window.URL || window.webkitURL).createObjectURL(file);
